import React, { useState, useContext, useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import './style/BottomModal.css';
import { CartContext } from './CartContext';
import { FavoriteContext } from './FavoriteContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_URL = `${process.env.REACT_APP_API_URL}v1`;
const API_KEY = '12345xxa';

function OrdersBottomModal({ isOpen, onClose, product }) {
    const { addToCart } = useContext(CartContext);
    const { addToFavorites, removeFromFavorites, favorites } = useContext(FavoriteContext);
    const [showAddedMessage, setShowAddedMessage] = useState(false);
    const [showFavoriteMessage, setShowFavoriteMessage] = useState(false);
    const [isFavorite, setIsFavorite] = useState(false);
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (product) {
            setIsFavorite(favorites.some(fav => fav.id === product.id));
        }
    }, [favorites, product]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${API_URL}/productCategories`, {
                    headers: { 'x-api-key': API_KEY }
                });
                setCategories(response.data);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchCategories();
    }, []);

    if (!product) return null; // If no product is selected, return null

    const handleAddToCart = () => {
        addToCart(product);
        setShowAddedMessage(true);
        setTimeout(() => {
            setShowAddedMessage(false);
        }, 2000);
    };

    const toggleFavorite = () => {
        if (isFavorite) {
            removeFromFavorites(product.id);
        } else {
            addToFavorites(product);
            setShowFavoriteMessage(true);
            setTimeout(() => {
                setShowFavoriteMessage(false);
            }, 2000);
        }
        setIsFavorite(!isFavorite);
    };

    const category = categories.find(cat => cat.id === product.id_product_category);

    const handleCategoryClick = (categoryId) => {
        navigate(`/catalog?category=${categoryId}`);
    };

    return (
        <div className={isOpen ? "overlay-bottom-modal open" : "overlay-bottom-modal"} onClick={onClose}>
            <div className="modal-bottom-modal" onClick={e => e.stopPropagation()}>
                {showAddedMessage && (
                    <div className="global-added-message">Товар добавлен в корзину</div>
                )}
                {showFavoriteMessage && (
                    <div className="global-favorite-message">Товар добавлен в избранное</div>
                )}
                <div className="content-bottom-modal">
                    <div className="content-bottom-modal-header">
                        <div className="content-bottom-modal-jump">
                            <span className="content-bottom-modal-jump-1">
                                <a href="/">Главная</a>
                            </span>
                            <span className="content-bottom-modal-jump-4">
                                &bull;
                            </span>
                            <span className="content-bottom-modal-jump-2">
                                <a href="#" onClick={() => handleCategoryClick(product.id_product_category)}>{category?.name}</a>
                            </span>
                            <span className="content-bottom-modal-jump-4">
                                &bull;
                            </span>
                            <span className="content-bottom-modal-jump-3">
                                <a href={`/product/${product.id}`}>{product.name}</a>
                            </span>
                        </div>
                        <div className="content-bottom-modal-close">
                            <button onClick={onClose} className="content-bottom-modal-close-1"><CloseIcon /></button>
                        </div>
                    </div>

                    <div className="content-bottom-modal-basic">
                        <div className="content-bottom-modal-pictures">
                            <div className="content-bottom-modal-basic-pictures">
                                <img 
                                    src={`${process.env.REACT_APP_IMAGES_URL}/${product.product_photo}`} 
                                    alt={product.name} 
                                />
                            </div>
                        </div>
                        
                        <div className="content-bottom-modal-information">
                            <div className="content-bottom-modal-title">
                                <h2 className="content-bottom-modal-title-1">
                                    {product.name}
                                </h2>
                            </div>
                            <div className="content-bottom-modal-characteristic">
                            </div>
                            <div className="content-bottom-modal-basic-purchase">
                                <div className="content-bottom-modal-basic-purchase-1">
                                    <div className="content-bottom-modal-basic-purchase-1-1">
                                        <span className="content-bottom-modal-basic-purchase-1-3">
                                            {product.price} T
                                        </span>
                                    </div>
                                    <div className="content-bottom-modal-basic-purchase-1-2">
                                        <span className="content-bottom-modal-basic-purchase-1-4">
                                            {product.oldPrice} 
                                        </span>
                                    </div>
                                </div>
                                <div className="content-bottom-modal-basic-purchase-2">
                                    <div className="content-bottom-modal-basic-purchase-2-1-1">
                                        <button className="content-bottom-modal-basic-purchase-2-1" onClick={handleAddToCart}>
                                            <ShoppingCartIcon /> В корзину
                                        </button>
                                    </div>
                                </div>
                                <div className="content-bottom-modal-basic-purchase-3">
                                    <button className="content-bottom-modal-basic-purchase-3-1" onClick={toggleFavorite} style={{ color: isFavorite ? 'red' : 'grey' }}>
                                        <FavoriteIcon />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-bottom-modal-description">
                        <div className="content-bottom-modal-description-1">
                            <h2 className="content-bottom-modal-description-1-1">
                                Описание
                            </h2>
                        </div>
                        <div className="content-bottom-modal-description-2">
                            <p className="content-bottom-modal-description-2-1">
                                {product.description}
                            </p>
                        </div>
                    </div>

                    <div className="content-bottom-modal-general-information">
                        <div className="content-general-information-1">
                            <h2 className="content-general-information-1-1">
                                Общая информация
                            </h2>
                        </div>
                        <div className="content-general-information-2">
                            <div className="content-general-information-2-1">
                                <div className="content-general-information-2-1-1">
                                    <span className="content-general-information-text-1">
                                        Страна производитель
                                    </span>
                                    <span className="content-general-information-text-3">
                                        {product.manufacturer_country}
                                    </span>
                                </div>
                                <div className="content-general-information-2-1-1">
                                    <span className="content-general-information-text-1">
                                        Вид упаковки
                                    </span>
                                    <span className="content-general-information-text-3">
                                        {product.type_of_packaging || 'Не указано'}
                                    </span>
                                </div>
                                <div className="content-general-information-2-1-1">
                                    <span className="content-general-information-text-1">
                                        Условия хранения
                                    </span>
                                    <span className="content-general-information-text-3">
                                        {product.storage_conditions || 'Не указано'}
                                    </span>
                                </div>
                            </div>
                            <div className="content-general-information-2-2">
                                <div className="content-general-information-2-2-1">
                                    <span className="content-general-information-text-1">
                                        Брэнд
                                    </span>
                                    <span className="content-general-information-text-3">
                                        {product.brand || 'Не указано'}
                                    </span>
                                </div>
                                <div className="content-general-information-2-2-1">
                                    <span className="content-general-information-text-1">
                                        Срок хранения
                                    </span>
                                    <span className="content-general-information-text-3">
                                        {product.shelf_life || 'Не указано'}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="content-general-information-3">
                            <div className="content-general-information-3-1">
                                <span className="content-general-information-3-1-1">
                                    {product.additionalInfo || 'Нет дополнительной информации'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrdersBottomModal;
